export default () => {
  const headerLayout = document.querySelector(".layout__header");

  const getPageHeaderHeight = () => {
    if (headerLayout) return headerLayout.offsetHeight;
  };

  const getPageHeaderMainHeight = () => {
    const headerLayout = document.querySelector(
      ".layout__header .page-header--main"
    );
    if (headerLayout) return headerLayout.offsetHeight;
  };

  const handleGlobalHeader = () => {
    const contextHeader = document.querySelectorAll(".layout__header-fixed");
    const mobileBreakpoint = window.matchMedia("(max-width: 959px)").matches;
    const isFixed = "is-fixed";

    var appBanner = document.querySelectorAll(".app-banner");
    var appBannerHeight = 0;
    var headerTopOffset = 0;
    var headerTopHeight = 0;

    if (appBanner.length) {
      var appBannerHeight = appBanner[0].clientHeight;
    }

    for (let i = 0; i < contextHeader.length; i++) {
      var context = contextHeader[i];
      var headerWrapper = context.querySelectorAll(".page-header-wrapper");
      var header = context.querySelectorAll(".page-header--main");
      var headerTop = context.querySelectorAll(".page-header--top");

      if (headerTop.length) {
        var headerTopHeight = headerTop[0].clientHeight;
        var headerTopOffset = headerTop[0].offsetTop;
      }
    }

    if (contextHeader.length) {
      if (header.length) {
        const addHeightHeader = () => {
          var headerHeight = header[0].clientHeight;
          headerWrapper[0].style.height = `${headerHeight - 1}px`;
        };

        window.addEventListener("load", () => addHeightHeader());
        window.addEventListener("resize", () => addHeightHeader());
      }

      const headerFixed = () => {
        const offsetTop = window.pageYOffset;
        var headerOffset = headerTopOffset + headerTopHeight + appBannerHeight;

        if (offsetTop > headerOffset) {
          header[0].classList.add(isFixed);
        } else {
          header[0].classList.remove(isFixed);
        }
      };

      window.addEventListener("load", () => headerFixed());
      window.addEventListener("scroll", () => headerFixed());
    }
  };

  getPageHeaderMainHeight();
  handleGlobalHeader();
  window.addEventListener("resize", () => handleGlobalHeader());
};